const FALSY_STRINGS = ["", "0", "false"];

const isOptedIn = (optIn?: string | boolean | null): boolean =>
  typeof optIn === "string" ? !FALSY_STRINGS.includes(optIn) : Boolean(optIn);

export { isOptedIn };
